<template>
	<div class="content-page content-page--logo-history">
		<CustomerNav />
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<!--DEV NOTE: title--detail changes based on the company the user is viewing-->
				<h2 class="content-page__title">
					Logos History
					<span class="content-page__title--detail"
						>- (1) Douglas Jeep Atlanta South</span
					>
				</h2>
			</div>
		</div>
		<div class="results-toolbar results-toolbar--quick-filter ">
			<div class="results-toolbar__filter">
				<!--DEV NOTE: Component is pending development's implemention. No label and no helper text needed for this filter-->
				<Dropdown />
			</div>
			<div class="results-toolbar__counter">
				<!--DEV NOTE: Component is pending development's implemention.-->
				<ResultCounter />
			</div>
		</div>
		<!--DEV NOTE: Component is pending development's implemention. Mobile table Variation 1, no select-->
		<Table />
	</div>
</template>

<script>
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import ResultCounter from '@/site-components/result-counter/result-counter';
import Table from '@/components/shells/table/table';
import CustomerNav from '@/sections/shared/customer-navegation';

export default {
	name: 'LogoHistory',
	components: {
		Breadcrumbs,
		Dropdown,
		ResultCounter,
		Table,
		CustomerNav
	},
	data() {
		return {
			// NOTE FOR DEV: Breadcrumbs shown just temporary for testing styles. This comment should be removed once dev updates accordingly
			// Customer names over 14 characters (including spaces) should be trunacted and concatinated with the previous page name
			// examples: Douglas Jeep, Inc. should show as Douglas Jeep, ... Integrations
			// Bullard would should as Bullard Integrations
			urlNames: [
				{ url: 'clients', name: 'Clients' },
				{
					url: 'logos',
					name: 'Douglas Jeep, ...' + ' Logos'
				},
				{ name: 'Logos History' }
			]
		};
	}
};
</script>
